import React from 'react';
import PropTypes from 'prop-types';
import { MEASUREMENT_TYPE } from '@nike/ciclp-config';
import {
  BRA_SIZE_CALCULATION_TABLE,
  BRA_SIZE_CALCULATION_TABLE_ASIA,
  isAsiaBraSizeCountry,
} from '@nike/ciclp-config/braSizeFinder';
import {
  ButtonStyled,
  DropDownStyled,
} from '@nike/nike-design-system-components';
import { Heading, HeadingLevel } from '@nike/web-a11y-ariakit-react';
import styles from './styles.styl';
import { UnitsToggleContainer } from '../../containers/unitsToggleContainer';
import { formatDropdownOptionValue, getMeasuremerntUnits } from './helpers';

export const UnderbustInputSlide = ({
  underbustValue,
  selectedUnits,
  translations,
  onNextClick,
  onSelect,
  title,
  copy,
  countryCode,
}) => {
  const braSizeCalculationTable = isAsiaBraSizeCountry(countryCode)
    ? BRA_SIZE_CALCULATION_TABLE_ASIA
    : BRA_SIZE_CALCULATION_TABLE;
  const dropdownOptions = braSizeCalculationTable.map(({ underbust }) => {
    return {
      label: formatDropdownOptionValue(
        underbust[selectedUnits],
        selectedUnits,
        translations,
      ),
      value: underbust[selectedUnits],
    };
  });

  const a11ySwitchDescription =
    translations.toggle_in_cm_a11y_desc ||
    'Toggle between inches and centimeters';

  return (
    <div className={styles.content} data-testid="content">
      <HeadingLevel level={3}>
        <Heading
          className={styles.contentHeading}
          data-testid="content-heading"
        >
          {title}
        </Heading>
      </HeadingLevel>
      <p className={styles.contentCopy} data-testid="content-copy">
        {copy}
      </p>
      <div
        className={styles.unitsToggleWrapper}
        data-testid="units-toggle-wrapper"
      >
        <UnitsToggleContainer
          unitsType={MEASUREMENT_TYPE}
          values={getMeasuremerntUnits(translations)}
          a11ySwitchDescription={a11ySwitchDescription}
        />
      </div>
      <div className={styles.inputWrapper} data-testid="input-wrapper">
        <DropDownStyled
          name="underbust"
          id="underbust"
          placeholder={translations.bra_size_finder_select_placeholder}
          options={dropdownOptions}
          label={translations.bra_size_finder_select_placeholder}
          value={underbustValue}
          onChange={event => onSelect(event.target.value)}
        />
      </div>
      <div>
        <ButtonStyled
          appearance="primary"
          onClick={onNextClick}
          data-qa="next-button"
          disabled={!underbustValue}
          size="responsive"
        >
          {translations.next}
        </ButtonStyled>
      </div>
    </div>
  );
};

UnderbustInputSlide.propTypes = {
  copy: PropTypes.string,
  countryCode: PropTypes.string,
  onNextClick: PropTypes.func,
  onSelect: PropTypes.func,
  selectedUnits: PropTypes.string,
  title: PropTypes.string,
  translations: PropTypes.shape({
    bra_size_finder_select_placeholder: PropTypes.string,
    next: PropTypes.string,
    toggle_in_cm_a11y_desc: PropTypes.string,
  }),
  underbustValue: PropTypes.string,
};
